import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import AddAccont from "../../assets/SVG/addAccont";
import DashboardIcon from "../../assets/SVG/dashboard";
import Group from "../../assets/SVG/group";
import ProjectIcon from "../../assets/SVG/projectIcon";
import ReportIcon from "../../assets/SVG/reportIcon";
import SettingIcon from "../../assets/SVG/settingIcon";
import SupportIcon from "../../assets/SVG/supportIcon";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import FlagIcon from "../../assets/SVG/flagIcon";
import SidebarGroup from "./sidebarGroup";
import SidebarAreaManager from "../areaManager/sidebarAreaManager";
import DownArrow from "../../assets/SVG/downArrow";
import logo from "../../assets/image/logo.png";

export function OptionsSidebar({
  icon,
  text,
  select,
  onClick,
  href,
  arrowIcon,
}) {
  return (
    <>
      {href ? (
        <Link to={href}>
          <Box
            sx={{ cursor: "pointer", mt: "10px" }}
            color={
              !arrowIcon
                ? select
                  ? "var(--emr-disable)"
                  : "white"
                : "var(--emr-disable)"
            }
            display="flex"
            bgcolor={!arrowIcon ? (!select ? "#126E83" : "white") : "white"}
            padding="8px 6px"
            borderRadius="9px"
            onClick={onClick}
          >
            <Box display="flex">
              <Box display="flex">
                {icon}
                <Typography mr="10px" fontSize="16px">
                  {text}
                </Typography>
              </Box>
              {arrowIcon && (
                // <Box sx={{  }}>
                <DownArrow transform={!select ? true : false} />
                // </Box>
              )}
            </Box>
          </Box>
        </Link>
      ) : (
        <Box>
          <Box
            sx={{ cursor: "pointer", mt: "10px" }}
            color={
              !arrowIcon
                ? select
                  ? "var(--emr-disable)"
                  : "white"
                : "var(--emr-disable)"
            }
            display="flex"
            bgcolor={!arrowIcon ? (!select ? "#126E83" : "white") : "white"}
            padding="8px 6px"
            borderRadius="9px"
            onClick={onClick}
          >
            <Box display="flex">
              <Box display="flex">
                {icon}
                <Typography mr="10px" fontSize="16px">
                  {text}
                </Typography>
              </Box>
              {arrowIcon && (
                // <Box sx={{  }}>
                <DownArrow transform={!select ? true : false} />
                // </Box>
              )}
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
}

export default function Sidebar({ Role, data, setData,sidebarAreaData }) {
  const [select, setSelect] = useState(0);
  return (
    <>
      <Box
        sx={{
          width: "250px",
          height: "90vh",
          borderRadius: "17px",
          background: "#FFF",
          mt: "19px",
          padding: "16px",
          display: "grid",
          alignContent: "space-between",
          overflow: "hidden",
        }}
        // className='!w-[215px]'
      >
        <Box
          sx={{
            overflow: "auto",
            "::-webkit-scrollbar": {
              display: "none",
            },
          }}
        >
          <Box textAlign="center">
            <img style={{ width: "80px", height: "auto" }} src={logo} />
          </Box>
          <Box height="10px"></Box>
          {Role?.role === "ADMIN" && (
            <Box>
              <OptionsSidebar
                href="/"
                onClick={() => setSelect(0)}
                select={select === 0 ? false : true}
                text="داشبورد"
                icon={
                  <DashboardIcon
                    color={select === 0 ? "white" : "var(--emr-disable)"}
                  />
                }
              />
              <OptionsSidebar
                href="/groups"
                onClick={() => setSelect(1)}
                select={select === 1 ? false : true}
                text="گروه ها"
                icon={
                  <Group
                    color={select === 1 ? "white" : "var(--emr-disable)"}
                  />
                }
              />
              <OptionsSidebar
                href="/projects"
                onClick={() => setSelect(2)}
                select={select === 2 ? false : true}
                text="پروژه"
                icon={
                  <ProjectIcon
                    color={select === 2 ? "white" : "var(--emr-disable)"}
                  />
                }
              />
              <OptionsSidebar
                href="/acconts"
                onClick={() => setSelect(3)}
                select={select === 3 ? false : true}
                text="ثبت‌نام کنندگان"
                icon={
                  <AddAccont
                    color={select === 3 ? "white" : "var(--emr-disable)"}
                  />
                }
              />
              <OptionsSidebar
                href="/reports"
                onClick={() => setSelect(4)}
                select={select === 4 ? false : true}
                text="گزارشات"
                icon={
                  <ReportIcon
                    color={select === 4 ? "white" : "var(--emr-disable)"}
                  />
                }
              />
            </Box>
          )}
          {Role?.role === "GROUP" && <SidebarGroup />}
          {Role?.role === "JAHADI" && (
            <SidebarAreaManager Role={Role} sidebarAreaData={sidebarAreaData} data={data} setData={setData} />
          )}
        </Box>
        <Box sx={{ borderTop: "solid 1px var(--emr-disable)" }}>
          <OptionsSidebar
            onClick={() => setSelect(10)}
            select={select === 10 ? false : true}
            text="داشبورد"
            icon={
              <SupportIcon
                color={select === 10 ? "white" : "var(--emr-disable)"}
              />
            }
          />
          <OptionsSidebar
            onClick={() => setSelect(11)}
            select={select === 11 ? false : true}
            text="گروه ها"
            icon={
              <SettingIcon
                color={select === 11 ? "white" : "var(--emr-disable)"}
              />
            }
          />
        </Box>
      </Box>
    </>
  );
}
